import React, { Component } from 'react'
import Select from 'react-select'
import apiService from '../../services/ApiService'

class KitchensScope extends Component {
    constructor() {
        super()
        this.state = {
            kitchensList: {},
            selectedCity:{}
        }
        this.isComponentStillMounted = true
    }

    componentDidMount() {
         this.getKitchensScopeList(this.props.type)
    }

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }

     componentDidUpdate() {

       this.getKitchensScopeList(this.props.type)
    }

    getKitchensScopeList = (type) => {
        apiService.getKitchensScopeList(type)
            .then(listData => {
                if (listData && this.isComponentStillMounted) {
                     this.setState({
                        kitchensList: listData.data
                    })                    
                }
            })
            .catch(err => {
                console.error("Error data: ", err)
            })
    }
    

    render() {
        let list = {}
        list = Object.keys(this.state.kitchensList).map((value,index) => {
            
            return {
                label : this.state.kitchensList[value],
                value : value
            }
        })
        list.sort((a,b) => a.label.localeCompare(b.label));

        return (
            <div>
                <Select
                value={this.props.selectedValue}
                placeholder="Select Kitchen"
                options={list}
                onChange={(e) => { (e) ? this.props.kitchenChange(e) : this.props.kitchenChange([])}}
                />
            </div>
        )
    }
}
export default KitchensScope


// WEBPACK FOOTER //
// ./src/common/DropDowns/KitchensScope.js